module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav-small.1747f553.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/PrevSliderButton/images/prev-nav-small.png
// module id = 3157
// module chunks = 11